import React, { useState } from 'react';
import Button from '../../../../../component/ui/Button';
import PageLoader from '../../../../../component/PageLoader';
import useUsers from './hooks/useUsers';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import Table from '../../../../../component/table/Table';
import CreateUserModal from './components/createUserModal';
import UserDrawer from './components/userDrawer';
import SettingHeaderComponent from '../../components/settingHeaderComponent';

export default function SettingsUsers({ activeTab }) {
	const {
		usersList,
		getUsersList,
		headerDropDown,
		setHeaderDropDown,
		loader,
		sortDataList,
		sortDirection,
		handleFilterData,
		setBulkAction,
		bulkAction,
		onRowClick,
		handleDeselectAll,
		handleDisable,
	} = useUsers();
	const [isOpenModel, setIsOpenModal] = useState(false);
	const [isDrawerOpen, setIsDrawerOpen] = useState(false);
	const [isEdit, setIsEdit] = useState(false);
	const [selectedUserId, setSelectedUserId] = useState('');
	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};

	const usersTableColumn = [
		{
			field: '',
			headerClass: 'HeaderBg',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			minWidth: 50,
			maxWidth: 50,
			autoHeight: true,
			lockPosition: true,
			cellRenderer: (params) => {
				return (
					<div
						className="d-flex align-items-center"
						style={{ height: '120px' }}
					>
						<input
							type="checkbox"
							checked={bulkAction.includes(params.data.id)}
							onChange={(e) => {
								const value = e.target.checked;
								if (value) {
									var newList = [...bulkAction, params.data.id];
									setBulkAction(newList);
								} else {
									var updatedList = bulkAction.filter((data) => data !== params.data.id);
									setBulkAction(updatedList);
								}
							}}
						/>
					</div>
				);
			},
		},
		{
			field: 'USER DETAILS',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 500,
			flex: 1,
			autoHeight: true,
			cellClass: 'left-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'first_name', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								USER DETAILS
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.first_name]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				const data = JSON.parse(params.data['user']);
				return (
					<div className="d-flex gap-3 align-items-center">
						<div
							className="text-center fs-4 d-flex justify-content-center align-items-center"
							style={{
								backgroundColor: '#D9D9D9',
								borderRadius: '30px',
								width: '50px',
								height: '50px',
								padding: '5px',
							}}
						>
							{data.name
								.split(' ')
								.map((w) => w[0])
								.join('')
								.toUpperCase()}
						</div>
						<div style={{ display: 'flex', flexDirection: 'column' }}>
							<div
								className="fs-5 fw-semibold p-1 cursor-pointer"
								style={{ height: '25px', color: '#2E63F6' }}
								onClick={(e) => {
									e.stopPropagation();
									setIsDrawerOpen(true);
									setSelectedUserId(data.id);
								}}
							>
								{data?.name}
							</div>
							<div
								className="fs-5 fw-light text-dark p-1"
								style={{ height: '25px' }}
							>
								{data?.phone_number}
							</div>
							<div
								className="fs-5 fw-light text-dark p-1"
								style={{ height: '25px' }}
							>
								{data?.email}
							</div>
							<div
								className="fs-5 fw-light p-1"
								style={{ color: data.is_active ? '#68C230' : '#DC3545', height: '45px' }}
							>
								{data?.is_active ? 'Active' : 'Inactive'}
							</div>
						</div>
					</div>
				);
			},
		},
		{
			field: 'ROLES',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			cellClass: 'center-align',
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => sortDataList({ order_by: 'roles', sort_by: 'asc' })}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								ROLES
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.roles]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				return (
					<div
						className="d-flex align-items-center"
						style={{ height: '120px' }}
					>
						{params.data.role}
					</div>
				);
			},
		},
		{
			field: 'ACTION',
			headerClass: 'HeaderBg left-align',
			suppressSizeToFit: true,
			minWidth: 200,
			maxWidth: 250,
			flex: 1,
			cellClass: 'left-align',
			cellRenderer: (params) => {
				const data = JSON.parse(params.data['action']);
				return (
					<div
						className="d-flex gap-3 align-items-center justify-content-center"
						style={{ height: '120px' }}
					>
						<div
							className="d-flex justify-content-center fs-6 fw-light text-center rounded-4 px-4 bg-primary cursor-pointer text-white"
							onClick={(e) => {
								e.stopPropagation();
								setIsEdit(true);
								setIsOpenModal(true);
								setSelectedUserId(data.id);
							}}
						>
							Edit
						</div>
						<div
							className="fs-6 fw-light rounded-4 px-4 cursor-pointer text-white"
							style={{ backgroundColor: data.is_active ? '#FF0000' : '#0d6efd' }}
							onClick={(e) => {
								handleDisable(e, data.id, !data.is_active);
							}}
						>
							{data.is_active ? 'Disable' : 'Enable'}
						</div>
					</div>
				);
			},
		},
	];

	return (
		<div>
			<SettingHeaderComponent title={activeTab} buttons={[
				{
					id: 1,
					button: 'Add User',
					add: true,
					close: false,
					disabled: false,
					handler: () => {
						setIsOpenModal(true);
						setIsEdit(false);
						setSelectedUserId('');
					},
					className: 'btn-primary',
				},
			]}
			/>
			<div style={{ backgroundColor: '#EDEDF7', position: 'sticky', top: 0, zIndex: 100 }}>
				<div className="d-flex pt-2 px-3 pb-3 justify-content-between align-items-center">
					<div
						className="product-pg-header tax-dropdown-header p-0"
						style={{
							position: 'sticky',
							top: 0,
							zIndex: 100,
						}}
					>
						<div className="dropdown text-end">
							<a
								className="link-dark text-decoration-none dropdown-toggle p-0"
								id="dropdownUser1"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								<span className="fs-3 fw-bold">{headerDropDown}</span>
							</a>
							<ul
								className="dropdown-menu font-14"
								aria-labelledby="dropdownUser1"
								style={{ minWidth: '200px', zIndex: '10000' }}
							>
								<li>
									<a
										className="dropdown-item border-0"
										onClick={() => handleFilterData('All Users', '', '')}
									>
										All Users
									</a>
								</li>
								<li>
									<a
										className="dropdown-item border-0"
										onClick={() => handleFilterData('Active Users', 'active', 'status')}
									>
										Active Users
									</a>
								</li>
								<li>
									<a
										className="dropdown-item border-0"
										onClick={() => handleFilterData('Inactive Users', 'inactive', 'status')}
									>
										Inactive Users
									</a>
								</li>
								<li>
									<a
										className="dropdown-item border-0"
										onClick={() => handleFilterData('Free Users', 'free', 'plan')}
									>
										Free Users
									</a>
								</li>
								<li>
									<a
										className="dropdown-item border-0"
										onClick={() => handleFilterData('Paid Users', 'paid', 'plan')}
									>
										Paid Users
									</a>
								</li>
							</ul>
						</div>
					</div>
					{/* <Button
						type="button"
						className="mt-0 btn-primary fs-5 fw-light add-pro py-1"
						button="Add User"
						add
						onClick={() => {

						}}
					/> */}
				</div>
			</div>
			{loader ? (
				<PageLoader />
			) : (
				<div className="productTable-body">
					<Table
						row={usersList}
						coloum={usersTableColumn}
						className="productTable"
						onRowClick={onRowClick}
						bulkAction={bulkAction}
						action={setBulkAction}
						onDeselectAll={handleDeselectAll}
					/>
				</div>
			)}
			{isOpenModel && (
				<CreateUserModal
					isOpenModal={isOpenModel}
					setIsOpenModal={setIsOpenModal}
					userId={selectedUserId}
					isEdit={isEdit}
					getUsersList={getUsersList}
				/>
			)}
			{
				<UserDrawer
					setIsOpenModal={setIsOpenModal}
					setIsEdit={setIsEdit}
					isOpen={isDrawerOpen}
					onClose={() => setIsDrawerOpen(false)}
					id={selectedUserId}
				/>
			}
		</div>
	);
}
